import { Effect } from "../../Materials/effect";
var name = 'fogFragment';
var shader = "#ifdef FOG\nfloat fog=CalcFogFactor();\ncolor.rgb=fog*color.rgb+(1.0-fog)*vFogColor;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var fogFragment = { name: name, shader: shader };
//# sourceMappingURL=fogFragment.js.map